Ext.define('SA.Histogram', {
    singleton: true,

    build({cfg, data}) {
        var frameSize = SA.HistogramFrameSizeResolver.resolve({cfg, data}),
            parts = SA.HistogramParts.get({cfg, frameSize, data});

        return SA.Chart.create({
            padding: cfg.layout.chartPadding,
            titleOffset: cfg.layout.titleOffset,
            frameSize,

            titles: {
                chart: parts.chartTitle,
                yAxis: parts.yAxisTitle,
                xAxis: parts.xAxisTitle
            },

            content: [
                parts.gridLines,
                parts.frame,
                parts.bars,
                parts.yLabels,
                parts.xLabels
            ]
        });
    }
});